export const GENERAL_PROJECT_LIST_CONTRACT = Object.freeze({
  response: {
    // Preserve the outer response so pagination metadata remains available.
    envelope: [],
  },
});

export const buildGeneralProjectPageUrl = (params, page) => {
  const searchParams = new URLSearchParams(params || {});
  searchParams.set('page', String(page));
  return `/general-project-info?${searchParams.toString()}`;
};

export const normalizeGeneralProjectPage = (payload) => {
  if (Array.isArray(payload)) {
    return { records: payload, pagination: {} };
  }

  const records = payload?.data ?? payload?.Data ?? payload?.items ?? payload?.Items ?? [];
  const pagination = payload?.pagination ?? payload?.Pagination ?? payload ?? {};

  return {
    records: Array.isArray(records) ? records : [],
    pagination,
  };
};

export const getGeneralProjectTotalPages = (pagination) => {
  const explicitTotalPages = Number(pagination?.totalPages ?? pagination?.TotalPages);
  if (Number.isFinite(explicitTotalPages) && explicitTotalPages > 0) {
    return Math.floor(explicitTotalPages);
  }

  const totalRecords = Number(pagination?.totalRecords ?? pagination?.TotalRecords);
  const limit = Number(pagination?.limit ?? pagination?.Limit);
  if (Number.isFinite(totalRecords) && Number.isFinite(limit) && totalRecords >= 0 && limit > 0) {
    return Math.max(1, Math.ceil(totalRecords / limit));
  }

  return 1;
};

export const fetchAllGeneralProjectPages = async (fetchPage, pageBatchSize = 5) => {
  const firstPageResult = await fetchPage(1);
  if (firstPageResult.error) return { error: firstPageResult.error };

  const firstPage = normalizeGeneralProjectPage(firstPageResult.data);
  const totalPages = getGeneralProjectTotalPages(firstPage.pagination);
  const records = [...firstPage.records];

  for (let firstPageNumber = 2; firstPageNumber <= totalPages; firstPageNumber += pageBatchSize) {
    const lastPageNumber = Math.min(totalPages, firstPageNumber + pageBatchSize - 1);
    const pageResults = await Promise.all(
      Array.from(
        { length: lastPageNumber - firstPageNumber + 1 },
        (_, index) => fetchPage(firstPageNumber + index)
      )
    );
    const failedPage = pageResults.find(result => result.error);
    if (failedPage) return { error: failedPage.error };

    pageResults.forEach(result => {
      records.push(...normalizeGeneralProjectPage(result.data).records);
    });
  }

  return { records };
};
